export const SIGN_TERMS_REQUEST = 'SIGN_TERMS_REQUEST';
export const SIGN_TERMS_SUCCESS = 'SIGN_TERMS_SUCCESS';
export const SIGN_TERMS_FAILURE = 'SIGN_TERMS_FAILURE';

export const CHECK_TERMS_REQUEST = 'CHECK_TERMS_REQUEST';
export const CHECK_TERMS_SUCCESS = 'CHECK_TERMS_SUCCESS';
export const CHECK_TERMS_FAILURE = 'CHECK_TERMS_FAILURE';

export const SIGN_TERMS_RESET = 'SIGN_TERMS_RESET';

export const SELECT_GUARANTEE_TYPE_REQUEST = 'SELECT_GUARANTEE_TYPE_REQUEST';
export const SELECT_GUARANTEE_TYPE_SUCCESS = 'SELECT_GUARANTEE_TYPE_SUCCESS';
export const SELECT_GUARANTEE_TYPE_FAILURE = 'SELECT_GUARANTEE_TYPE_FAILURE';
